<!--
 * @Description: 
 * @Date: 2021-12-29 15:59:32
-->
<template>
  <div class="search-box" style="justify-content:start">
    <div class="search-left">
      <div style="display:flex" v-if="!config || config.type !== 'month'">
        <el-select
          style="min-width:200px"
          class="search-item"
          clearable
          v-if="!isAuto"
          v-model="parent.searchQuery.auditGongyeStatus"
          placeholder="请选择任务状态"
        >
          <el-option label="审核中" :value="1"></el-option>
          <el-option label="审核通过" :value="2"></el-option>
          <el-option label="审核未通过" :value="3"></el-option>
        </el-select>
        <el-input
          class="search-item"
          v-model="parent.searchQuery.fullName"
          placeholder="项目参与人"
        ></el-input>
        <el-input
          v-if="parent.projectStructureType === 2"
          class="search-item"
          v-model="parent.searchQuery.userEnterpriseName"
          placeholder="个体"
        ></el-input>
        <el-input
          class="search-item"
          v-model="parent.searchQuery.phone"
          placeholder="手机号"
        ></el-input>
      </div>
      <div style="display:flex" v-else>
        <el-select
          v-model="parent.searchQuery.month"
          class="search-item"
          style="min-width:200px"
          placeholder="请选择月度"
        >
          <el-option
            v-for="date in taskDates"
            :key="date"
            :label="date"
            :value="date"
          />
        </el-select>
        <el-input
          class="search-item"
          v-model="parent.searchQuery.userName"
          placeholder="项目参与人"
        ></el-input>
        <el-input
          v-if="parent.projectStructureType === 2"
          class="search-item"
          v-model="parent.searchQuery.userEnterpriseName"
          placeholder="个体"
        ></el-input>
        <el-input
          class="search-item"
          v-model="parent.searchQuery.userPhone"
          placeholder="手机号"
        ></el-input>
      </div>
    </div>
    <div class="search-right">
      <el-button type="primary" @click="searchEventTrigger">搜索</el-button>
      <el-button
        v-if="!config || config.type !== 'month'"
        :disabled="receiveAllDisabled"
        type="primary"
        @click="receiveAll"
      >
        全部通过
      </el-button>
    </div>
  </div>
</template>

<script>
import { receive, channel } from '@/api/ajax';
export default {
  props: ['searchEvent', 'parent', 'config', 'isAuto'],
  data() {
    return {
      auditGongyeStatus: '',
      taskDates: []
    };
  },
  watch: {
    'parent.searchQuery.month'() {
      this.searchEvent();
    }
  },
  computed: {
    receiveAllDisabled() {
      if (this.config && this.config.type === 'month') {
        return false;
      }
      return !this.parent.tableData.some(item => item.auditGongyeStatus === 1);
    }
  },
  async created() {
    if (this.config.type === 'month') {
      channel.getMonthTask(this.$route.query).then(({ pdata }) => {
        this.taskDates = pdata.map(item => item.month || item.taskMonth);
        this.parent.searchQuery.month =
          this.parent.searchQuery.month || this.taskDates[0];
      });
    }
  },
  methods: {
    searchEventTrigger() {
      this.$emit('change');
      this.parent.watchFlag = false;
      this.searchEvent();
    },
    receiveAll() {
      receive
        .receiveTaskRecord({
          statementId: this.$route.query.statementId,
          isAll: 1,
          auditGongyeStatus: 2
        })
        .then(res => {
          this.parent.finishFlag = res.data.data;
          this.$message.success(res.data.message);
          this.parent.watchFlag = true;
          this.parent.searchEvent();
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.search-item {
  margin-right: 20px;
}
</style>
>
